import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex justify-content-start mb-10" }
const _hoisted_2 = { class: "d-flex flex-column align-items-start" }
const _hoisted_3 = { class: "d-flex align-items-center mb-2" }
const _hoisted_4 = { class: "symbol symbol-35px symbol-circle" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "ms-3 d-flex flex-column" }
const _hoisted_7 = { class: "fs-7 text-gray-900 text-hover-primary me-1" }
const _hoisted_8 = { class: "text-muted fs-7 mb-1" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "me-7 mb-4"
}
const _hoisted_11 = ["href"]
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 1,
  class: "img-thumbnail mw-300px",
  width: "320",
  height: "240",
  autoplay: ""
}
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Your browser does not support the video tag. ")
const _hoisted_17 = {
  key: 2,
  controls: ""
}
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Your browser does not support the audio element. ")
const _hoisted_21 = ["href"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi- fs-2 me-1" }, null, -1)
const _hoisted_23 = {
  key: 1,
  class: "p-3 rounded bg-gray-200 text-dark fw-bold mw-lg-400px",
  "data-kt-element": "message-text",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_24 = {
  key: 0,
  class: "badge badge-light-danger position-relative",
  style: {"right":"100%"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            alt: "Pic",
            src: _ctx.image
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.name), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.time), 1)
        ])
      ]),
      (_ctx.file && _ctx.file.type)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_ctx.file.type.match('image*'))
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createElementVNode("a", {
                    href: _ctx.file.path ?? _ctx.file.url,
                    target: "_blank",
                    class: ""
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.file.path ?? _ctx.file.url,
                      alt: "image",
                      class: "img-thumbnail mw-300px"
                    }, null, 8, _hoisted_12)
                  ], 8, _hoisted_11)
                ]))
              : (_ctx.file.type.match('video*'))
                ? (_openBlock(), _createElementBlock("video", _hoisted_13, [
                    _createElementVNode("source", {
                      src: _ctx.file.path ?? _ctx.file.url,
                      type: "video/mp4"
                    }, null, 8, _hoisted_14),
                    _createElementVNode("source", {
                      src: _ctx.file.path ?? _ctx.file.url,
                      type: "video/ogg"
                    }, null, 8, _hoisted_15),
                    _hoisted_16
                  ]))
                : (_ctx.file.type.match('audio*'))
                  ? (_openBlock(), _createElementBlock("audio", _hoisted_17, [
                      _createElementVNode("source", {
                        src: _ctx.file.path ?? _ctx.file.url,
                        type: "audio/ogg"
                      }, null, 8, _hoisted_18),
                      _createElementVNode("source", {
                        src: _ctx.file.path ?? _ctx.file.url,
                        type: "audio/mpeg"
                      }, null, 8, _hoisted_19),
                      _hoisted_20
                    ]))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 3,
                      href: _ctx.file.path ?? _ctx.file.url,
                      class: "nav-link btn btn-sm btn-color-gray-600 btn-active-color-primary btn-active-light-primary fw-bold px-4 me-1 collapsible active",
                      download: ""
                    }, [
                      _hoisted_22,
                      _createTextVNode(_toDisplayString(_ctx.translate("download")), 1)
                    ], 8, _hoisted_21))
          ]))
        : _createCommentVNode("", true),
      (_ctx.text)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createTextVNode(_toDisplayString(_ctx.text) + " ", 1),
            (_ctx.status)
              ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["bi", `bi-${_ctx.handleStatus(_ctx.status)}`])
                  }, null, 2)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}